import { Component, OnInit, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WorkItemModel } from '../../models/work-item';
import { UITabModel } from 'e5core-angular-services';
import { UiStyleService } from '../../services/ui-style.service';

@Component({
  selector: 'e5core-ui-work-tab-set',
  template: `
    <span [ngSwitch]="style.current()">
      <e5core-ui-work-tab-set-box *ngSwitchCase='0' [workItem$]='workItem$' [tabs]='tabs'></e5core-ui-work-tab-set-box>
      <e5core-ui-work-tab-set-bootstrap *ngSwitchCase='1' [workItem$]='workItem$' [tabs]='tabs'></e5core-ui-work-tab-set-bootstrap>
      <e5core-ui-work-tab-set-material *ngSwitchCase='2' [workItem$]='workItem$' [tabs]='tabs'></e5core-ui-work-tab-set-material>
    </span>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class E5coreUiWorkTabSetComponent implements OnInit {

  @Input() workItem$: BehaviorSubject<WorkItemModel> ;

  workItem: WorkItemModel ;
  tabs: UITabModel[] ;

  constructor(public style:UiStyleService, private cd: ChangeDetectorRef ) { }

  ngOnInit() {
    if (this.workItem$ == null) {
      console.error('e5core-ui-work-tab-set [workItem$] must have a BehaviorSubject<WorkItemModel>');
      return ;
    }
    this.workItem$.subscribe(
      workItem => {
        this.workItem = workItem ;
        // convert tabs associative array to a standard array
        this.tabs = workItem.tabs ;
        // if (this.workItem && this.workItem.tabs) {
        //   const tabList = this.workItem.tabs ;
        //   for (const tab of Object.values(tabList)) {
        //     //tab.errorCount = this.errorCount(tab.fieldSetRefs) ;
        //     this.tabs.push(tab) ;
        //   }
        // }

        this.cd.markForCheck();
      },
      e => this.workItem = null
    );
  }

  errorCount(fieldSetIds: string[]): number {
    if (!(this.workItem && this.workItem.fieldsets)) {
      return (0) ;
    }

    const fieldSets = this.workItem.fieldsets ;
    if (!fieldSets) {
      return (0) ;
    }

    return (0) ;
  }

}
